import React, { useRef } from "react";
import gsap from "gsap";
import OnColorContext from "../../../contexts/OnColorContext";
import useBreakpoint from "../../../hooks/useBreakpoint";
var ArrowSvg = function ArrowSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M16.672 13.002H4.5v-2h12.172l-5.364-5.364 1.414-1.414 7.778 7.778-7.778 7.778-1.414-1.414 5.364-5.364Z",
    fill: "#141414"
  }));
};
ArrowSvg.defaultProps = {
  width: "24",
  height: "24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var CartSvg = function CartSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M4.004 16V4h-2V2h3a1 1 0 0 1 1 1v12h12.438l2-8H8.004V5h13.72a1 1 0 0 1 .97 1.243l-2.5 10a1 1 0 0 1-.97.757H5.003a1 1 0 0 1-1-1Zm2 7a2 2 0 1 1 0-4 2 2 0 0 1 0 4Zm12 0a2 2 0 1 1 0-4 2 2 0 0 1 0 4Z",
    fill: "#000"
  }));
};
CartSvg.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
import IconAtm from "../../atoms/IconAtm";
import RoundedCornerIconAtm from "../../atoms/RoundedCornerIconAtm";
import { Container, DescriptionContainer, IconContainer, IconContent, Link, RightRoundeCornerWrapper, PriceElement, PriceContainer, RightRoundedCorner } from "./ProductListItemMol.styled";
var PRICE_ELEMENT_BACKGROUND = "white";
function ProductListItemMol(_ref) {
  var descriptionElement = _ref.descriptionElement,
    price = _ref.price,
    lowestPrice = _ref.lowestPrice,
    link = _ref.link,
    externalLink = _ref.externalLink;
  var iconRef = useRef(null);
  var isMediumUp = useBreakpoint("medium");
  var roundedCornerIconSize = 30;
  var tl;
  var onMouseOver = function onMouseOver() {
    if (isMediumUp) {
      if (tl) {
        tl.kill();
      }
      tl = gsap.timeline();
      var animateStep0 = function animateStep0() {
        tl.to(iconRef.current, {
          duration: 0.2,
          scale: 1.2,
          rotate: externalLink ? -20 : -10,
          ease: "slow",
          // eslint-disable-next-line @typescript-eslint/no-use-before-define
          onComplete: animateStep1
        });
      };
      var animateStep1 = function animateStep1() {
        tl.to(iconRef.current, {
          duration: 0.2,
          rotate: externalLink ? 20 : 10,
          // eslint-disable-next-line @typescript-eslint/no-use-before-define
          onComplete: animateStep2
        });
      };
      var animateStep2 = function animateStep2() {
        tl.to(iconRef.current, {
          duration: 0.2,
          scale: 1,
          rotate: 0,
          ease: "slow"
        });
      };
      animateStep0();
    }
  };
  var onMouseOut = function onMouseOut() {
    if (!tl) {
      tl = gsap.timeline();
    }
    tl.to(iconRef.current, {
      duration: 0,
      scale: 1,
      rotate: 0
    });
  };
  return /*#__PURE__*/React.createElement(Container, {
    onMouseEnter: onMouseOver,
    onMouseLeave: onMouseOut
  }, /*#__PURE__*/React.createElement(DescriptionContainer, {
    $backgroundImage: descriptionElement.backgroundImage
  }, /*#__PURE__*/React.createElement(OnColorContext.Provider, {
    value: descriptionElement.textOnColor
  }, /*#__PURE__*/React.createElement(Link, link, descriptionElement.content))), /*#__PURE__*/React.createElement(PriceContainer, null, /*#__PURE__*/React.createElement(PriceElement, {
    $background: PRICE_ELEMENT_BACKGROUND
  }, price, lowestPrice), /*#__PURE__*/React.createElement(RightRoundeCornerWrapper, {
    $background: PRICE_ELEMENT_BACKGROUND
  }, /*#__PURE__*/React.createElement(RightRoundedCorner, {
    $size: roundedCornerIconSize,
    $background: PRICE_ELEMENT_BACKGROUND
  }, /*#__PURE__*/React.createElement(RoundedCornerIconAtm, {
    size: roundedCornerIconSize,
    color: PRICE_ELEMENT_BACKGROUND
  }))), /*#__PURE__*/React.createElement(IconContainer, null, /*#__PURE__*/React.createElement(IconContent, null, /*#__PURE__*/React.createElement("div", {
    ref: iconRef
  }, /*#__PURE__*/React.createElement(IconAtm, {
    icon: externalLink ? ArrowSvg : CartSvg,
    sizeSpace: 3
  }))))));
}
export default ProductListItemMol;